<template>
    <div class="w-full flex items-stretch">
        <span
            class="inline-flex items-center px-3 border border-bordergray-100 border-r-0 rounded-l-md rounded-r-none text-xs text-gray-500 bg-gray-100 h-11 whitespace-nowrap"
            style="border-top-right-radius: 0; border-bottom-right-radius: 0;"
        >
            {{ label }}
        </span>

        <select
            v-if="mode === 'select'"
            :value="model"
            :disabled="disabled"
            class="stage-filter-input form-select flex-1 min-w-0 rounded-none border-0 h-11 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
            style="border-radius: 0;"
            @change="emitModel($event.target.value)"
        >
            <option
                v-for="option in options"
                :key="'approval-add-bar-option-' + option[valueKey]"
                :value="option[valueKey]"
            >
                {{ option[labelKey] }}
            </option>
        </select>

        <input
            v-else
            :value="model"
            :disabled="disabled"
            :placeholder="placeholder"
            class="stage-filter-input form-input flex-1 min-w-0 rounded-none border-0 h-11 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
            style="border-radius: 0;"
            type="text"
            @input="emitModel($event.target.value)"
        >

        <button
            :disabled="!canAdd"
            class="btn btn-gray shadow-sm rounded-l-none rounded-r-md flex-shrink-0 h-11 disabled:opacity-100 disabled:cursor-not-allowed"
            style="border-top-left-radius: 0; border-bottom-left-radius: 0;"
            type="button"
            @click="$emit('add')"
        >
            {{ $t(buttonText).toString() }}
        </button>
    </div>
</template>

<script>
export default {
    name: "approval-add-bar",
    emits: ['input', 'update:modelValue', 'add'],
    props: {
        label: {
            type: String,
            required: true,
        },
        mode: {
            type: String,
            default: "select",
            validator: (value) => ["select", "input"].includes(value),
        },
        modelValue: {
            type: [String, Number],
            default: undefined,
        },
        value: {
            type: [String, Number],
            default: null,
        },
        options: {
            type: Array,
            default: () => [],
        },
        valueKey: {
            type: String,
            default: "id",
        },
        labelKey: {
            type: String,
            default: "name",
        },
        placeholder: {
            type: String,
            default: "",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        canAdd: {
            type: Boolean,
            default: false,
        },
        buttonText: {
            type: String,
            default: "Add",
        },
    },
    computed: {
        model() {
            return this.modelValue !== undefined ? this.modelValue : this.value;
        },
    },
    methods: {
        emitModel(value) {
            this.$emit('update:modelValue', value);
            this.$emit('input', value);
        },
    },
};
</script>
